import { useState, useEffect, useCallback } from 'react';
import {
  fetchGameStats,
  getAccessToken,
  updateGameStats
} from '../lib/walterhouseApi';

export const useGameStats = (user, gameId = 'tenfinity') => {
  const [stats, setStats] = useState({
    highScore: 0,
    playCount: 0,
    lastPlayed: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load stats from WalterHouse API
  useEffect(() => {
    if (!user) {
      setStats({ highScore: 0, playCount: 0, lastPlayed: null });
      setLoading(false);
      return;
    }

    const loadStats = async () => {
      setError(null);
      try {
        const accessToken = getAccessToken();
        if (!accessToken) {
          setStats({ highScore: 0, playCount: 0, lastPlayed: null });
          return;
        }

        const result = await fetchGameStats(gameId, accessToken);
        setStats(result.stats);
      } catch (err) {
        console.error('Error loading stats:', err);
        setError(err.message || 'Failed to load stats');
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, [user, gameId]);

  // Update stats in WalterHouse API
  const updateStats = useCallback(async (newScore, sessionId = null) => {
    if (!user) return null;

    try {
      const accessToken = getAccessToken();
      if (!accessToken) return null;

      const now = new Date().toISOString();

      const updatedStats = await updateGameStats(
        gameId,
        {
          highScore: newScore,
          playCount: 1,
          lastPlayed: now,
          sessionId
        },
        accessToken
      );

      setStats({
        highScore: updatedStats.highScore,
        playCount: updatedStats.playCount,
        lastPlayed: updatedStats.lastPlayed || now
      });

      return updatedStats;
    } catch (error) {
      console.error('Error updating stats:', error);
      return null;
    }
  }, [user, gameId]);

  return { stats, loading, error, updateStats };
};
